import {v4 as uuidv4} from 'uuid';
import { thingsBoardMicroserviceUrl } from '../microservices/thingsboard_microservice';
export const GenerateDashboardStateId = async(profileId,dashboardId,accessToken) =>{
    try{
        let tries = 0;
        while(tries < 10){
            tries++;
            const dashboardStateId = uuidv4();
            const response = await fetch(`${thingsBoardMicroserviceUrl}/tenants/profiles/${profileId}/dashboards/${dashboardId}/states/${dashboardStateId}`,{
                method:'HEAD',
                headers:{
                    'Authorization':`Bearer ${accessToken}`
                }
            });
            if(response.status === 404) return dashboardStateId;
            else if(response.status !== 200) throw new Error(`Status code: ${response.status}`);
        }
    }
    catch(error){
        console.error('An error occurred when generating a dashboard state id',error);
    }
    return null;
}